import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { emailRegexp } from 'javascripts/common/regexp'
import { API } from 'javascripts/api'
import CSSModules from 'react-css-modules'
import ClientLoginLayout from 'spa/client/layouts/ClientLoginLayout'
import { useFlash } from 'spa/hooks/useFlash'
import styles from './style.module.scss'

const ClientSignup: React.FC = CSSModules<React.FC>(() => {
  const [flash, setFlash] = useFlash()
  const [email, setEmail] = useState<string>('')
  const [agreePrivacyPolicy, setAgreePrivacyPolicy] = useState<boolean>(false)
  const [emailError, setEmailError] = useState<string | null>(null)
  const [validEmail, setValidEmail] = useState<boolean>(false)
  const [waiting, setWaiting] = useState<boolean>(false)
  const { t } = useTranslation()
  const privacyPolicyUrl = 'https://crowdworks.co.jp/privacy_policy/01/'

  useEffect(() => {
    const valid = emailRegexp.test(email)

    setValidEmail(valid)
    if (valid || (email ?? '') === '') {
      setEmailError(null)
    }
    else {
      setEmailError(t('clientAuth.general.email.invalid'))
    }
  }, [email])

  const handleEmailChange: React.ChangeEventHandler<HTMLInputElement> = (event) => {
    event.preventDefault()

    setEmail(event.currentTarget.value)
  }

  const verifyEmail = () => {
    return API.verifyClientStaffEmail({ email: email, agreePrivacyPolicy: agreePrivacyPolicy })
  }

  const onSubmit: React.FormEventHandler<HTMLFormElement> = (event) => {
    event.preventDefault()

    setWaiting(true)
    verifyEmail().then(response => {
      setEmailError(null)
      setFlash({ ...flash, success: response.data.message })
      setWaiting(false)
    }).catch(error => {
      if (API.isAxiosError(error) && API.isBadRequestError(error.response) && error.response.data.operationId === 'verifyClientStaffEmail') {
        setEmailError(error.response.data.error)
        setFlash(null)
      }
      setWaiting(false)
    })
  }

  const disabled = () => (waiting || !validEmail || !agreePrivacyPolicy)

  return (
    <ClientLoginLayout flash={flash}>
      <div styleName='client-signup'>
        <div styleName='client-signup-inner'>
          <h1>アカウント発行</h1>
          <form onSubmit={onSubmit}>
            <div styleName='form-item'>
              <label styleName='form-item-label' htmlFor='input-email'>メールアドレス</label>
              <div styleName='form-item-inner'>
                <div styleName='form-item-content'>
                  <input type='email' id='input-email' className={emailError ? '-error' : ''} value={email} onChange={handleEmailChange}/>
                </div>
                {emailError && <div styleName='form-item-error'>{emailError}</div>}
              </div>
            </div>
            <div styleName='form-item'>
              <label styleName='form-item-label' />
              <div styleName='form-item-inner'>
                <div styleName='form-item-content'>
                  <label styleName='form-item-checkbox-label'>
                    <p>
                      <input
                        type='checkbox'
                        checked={agreePrivacyPolicy}
                        onChange={event => setAgreePrivacyPolicy(event.target.checked)}
                      />
                      個人情報については、<a href={privacyPolicyUrl} target="_blank">個人情報の取扱について</a>に従って適切に取り扱わせていただきます。
                    </p>
                    <p styleName="indent">本送信をもって個人情報の取り扱いについて同意します。</p>
                  </label>
                </div>
              </div>
            </div>
            <div styleName='form-item'>
              <div styleName='form-item-inner'>
                <div styleName='form-item-content'>
                  <input className={disabled() ? 'disabled' : ''} disabled={disabled()} type='submit' value='送信する' />
                </div>
              </div>
            </div>
          </form>
        </div>
        <div className='api-state' styleName='api-state'>
          {waiting && <div className='api-waiting' />}
        </div>
      </div>
    </ClientLoginLayout>
  )
}, styles)

export default ClientSignup
